<script setup>


</script>


<template>
  <section>
    <div class="preloader">
      <img src="@/assets/img/logo.png" alt="logo" class="preloader_img">
    </div>
  </section>
</template>


<style scoped>


  .preloader
  {
    position: fixed;
    height: 100%;
    width: 100%;
    background: #000;
    z-index: 1010;
  }

  .preloader_img
  {
    position: absolute;
    width: 208px;
    top: calc(50% - 20px);
    left: calc(50% - 104px);
  }


</style>